import Admin from '../pages/admin/pages/Admin'
import CreateAdmin from '../pages/admin/pages/CreateAdmin'
import AdminDetails from '../pages/admin/pages/AdminDetails'
import { USER_ROLES } from '../utils/userRole'

const permissions = [USER_ROLES.ADMIN]

const AdminRoutes = [
  {
    path: '/admin',
    component: Admin,
    exact: true,
    permissions,
  },
  {
    path: '/admin/create',
    component: CreateAdmin,
    exact: true,
    permissions,
  },
  {
    path: '/admin/edit/:id',
    component: CreateAdmin,
    exact: true,
    permissions,
  },
  {
    path: '/admin/details/:id',
    component: AdminDetails,
    exact: true,
    permissions,
  },
]

export default AdminRoutes
